import { Link, LinkProps } from 'react-router-dom'

import styled, { css } from 'styled-components'

const Wrapper = styled.div`
  position: fixed;
  background: ${p => p.theme.colors.light};
  height: 60px;
  width: 100%;
  bottom: 0px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-shadow: 5px -1px 15px rgba(0, 0, 0, 0.06);
  overflow: hidden;
  z-index: 1001;
`

const BtnBase = css`
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  outline: none;
  user-select: none;
  text-decoration: none;
  color: ${p => p.theme.colors.dark};
`

const BtnTabBar = styled(Link)<LinkProps>`
  ${BtnBase}
`

const BtnTabBarCustom = styled.div`
  ${BtnBase}
`

export { Wrapper, BtnTabBar, BtnTabBarCustom }
